<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("calculators_common.boost_type") }}
    </h4>
    <div
      class="d-flex-row justify-start exptra_options role_picker_container flex-wrap"
    >
      <button
        v-for="(tab, index) in tabs"
        :key="tab"
        class="d-flex-row flex-4 role_picker"
        @click="() => selectTab(index)"
        :class="[activeTab === index && 'selected']"
      >
        <p class="font-family-2 medium-l">
          {{ tab }}
        </p>
      </button>
    </div>
    <RolesPicker v-if="activeTab === 1" />
    <ChampionsPickerVue v-if="activeTab === 2" />
  </div>
</template>

<script>
import RolesPicker from "./RolesPicker.vue";
import ChampionsPickerVue from "../../commonpickers/ChampionsPicker.vue";
export default {
  data() {
    return {
      tabs: [
        this.$t("calculators_common.any_hero"),
        this.$t("calculators_common.specific_role"),
        this.$t("calculators_common.specific_hero"),
      ],
      activeTab: 0,
    };
  },

  methods: {
    selectTab(index) {
      this.activeTab = index;
    },
  },
  components: {
    RolesPicker,
    ChampionsPickerVue,
  },
  watch: {
    activeTab() {
      if (this.activeTab === 1) {
        // this.$store.commit("clearHeroes", []);
        this.checkoutStore.clearHeroes();
      } else if (this.activeTab === 2) {
        this.checkoutStore.clearRoles();
      }
    },
  },

  setup() {
    const { getGame } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGame,
      checkoutStore,
    };
  },
};
</script>
